import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Proxy = (props) => (<Svg {...props}>
    <Path d="M9.09 5.818H1.456m0 0 2.937-2.727M1.455 5.818l2.937 2.727M8 10.182h6.545m0 0-2.727 2.727m2.727-2.727-2.727-2.727" stroke={props?.color ?? '#393360'} strokeWidth={1.3} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Proxy;
